var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_3949)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1038_3949",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -21,
    y: -22,
    width: 123,
    height: 124
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.941 -21.6523H-20.8398V101.129H101.941V-21.6523Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1038_3949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7668 20.7306C75.4039 23.5661 73.2694 27.9137 74.0813 30.9308C74.9212 34.0489 78.9182 36.7629 78.9153 39.9176C78.9131 43.124 74.8976 45.8261 74.0737 48.901C73.2497 51.9759 75.3762 56.3237 73.775 59.1016C72.2001 61.8351 67.3816 62.187 65.0952 64.4674C62.8835 66.6743 62.5582 71.5067 59.7227 73.1438C56.8872 74.7809 52.5396 72.6464 49.5225 73.4582C46.4045 74.2982 43.6905 78.2951 40.5357 78.2923C37.3294 78.2901 34.6273 74.2746 31.5524 73.4506C28.4775 72.6267 24.1296 74.7532 21.3517 73.152C18.6182 71.5771 18.2663 66.7586 15.9859 64.4721C13.779 62.2605 8.94663 61.9352 7.30955 59.0997C5.67247 56.2642 7.80694 51.9166 6.99508 48.8995C6.15516 45.7815 2.15819 43.0674 2.16099 39.9127C2.16327 36.7064 6.17877 34.0043 7.00268 30.9294C7.8266 27.8544 5.70012 23.5066 7.30135 20.7287C8.87627 17.9952 13.6948 17.6433 15.9812 15.3629C18.1928 13.156 18.5181 8.32362 21.3536 6.68654C24.1891 5.04946 28.5367 7.18393 31.5538 6.37207C34.6719 5.53215 37.3859 1.53518 40.5406 1.53798C43.747 1.54025 46.4491 5.55576 49.524 6.37967C52.5989 7.20359 56.9467 5.07711 59.7247 6.67834C62.4581 8.25326 62.81 13.0718 65.0904 15.3582C67.2973 17.5698 72.1297 17.8951 73.7668 20.7306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5234 38.6317L36.9598 49.1705L54.5585 31.3672",
    stroke: "#27AE60",
    strokeWidth: 9.02802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_3949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.4466,
    height: 80.3494,
    fill: "white",
    transform: "translate(0.828125 0.015625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/successTick.df5bee1a1f343d19c728052978b9527d.svg";
export { ForwardRef as ReactComponent };